import { Place, PlaceJSON, PlaceTypes } from "../models/Place";
import { network } from "./index";
import { CognitoAuth } from "./CognitoAuth";
import { AxiosResponse } from "axios";

export class PlaceAPI {
  static async getPlaces(): Promise<Place[] | undefined> {
    try {
      const response = await network.callGet(Place.path);
      return response?.data?.map((place: PlaceJSON) => Place.fromJSON(place));
    } catch (error) {
      CognitoAuth.handleError(error, "getPlaces error");
      throw error;
    }
  }

  static async getPlace(id: number): Promise<Place> {
    try {
      const response = await network.callGet(Place.path + "/" + id);
      return Place.fromJSON(response?.data);
    } catch (error) {
      CognitoAuth.handleError(error, "getPlace error");
      throw error;
    }
  }

  static async savePlace(place: Place): Promise<Place> {
    try {
      let response: AxiosResponse | null;
      if (!place.id) {
        // creating new record
        response = await network.callPost(Place.path, place.toJSON(), true);
      } else {
        // updating existing record
        response = await network.callPost(
          Place.path + "/" + place.id,
          place.toJSON(),
          true
        );
      }
      return Place.fromJSON(response?.data);
    } catch (error) {
      CognitoAuth.handleError(error, "savePlace error");
      throw error;
    }
  }

  static async deletePlace(id: number): Promise<boolean> {
    try {
      await network.callDelete(Place.path + "/" + id, true);
      return true; // callDelete will throw error if back-end error
    } catch (error) {
      CognitoAuth.handleError(error, "deletePlace error");
      throw error;
    }
  }

  static singlePrimaryPlace(places?: Place[]): Place | undefined {
    return places?.find((place: Place) => place.type === PlaceTypes.Primary);
  }
}
